import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import UploadFileIcon from '../../../../assets/upload-file.svg'

interface UploadWavFileProps {
  onFileSelect: (file: File) => void
}

const UploadWavFile: React.FC<UploadWavFileProps> = ({ onFileSelect }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const isWavFile = (file: File) => {
    const type = (file.type || '').toLowerCase();
    if (type === 'audio/wav' || type === 'audio/x-wav' || type === 'audio/wave') {
      return true;
    }
    const name = (file.name || '').toLowerCase();
    return name.endsWith('.wav');
  }

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return;

    if (process.env.NODE_ENV !== 'production') {
      console.log('[UploadWavFile] file input change', {
        name: file.name,
        type: file.type,
        size: file.size,
      });
    }

    if (isWavFile(file)) {
      onFileSelect(file)
    }
  }

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
  }

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    const file = event.dataTransfer.files?.[0]
    if (!file) return;

    if (process.env.NODE_ENV !== 'production') {
      console.log('[UploadWavFile] file drop', {
        name: file.name,
        type: file.type,
        size: file.size,
      });
    }

    if (isWavFile(file)) {
      onFileSelect(file)
    }
  }

  return (
    <UploadContainer onClick={handleClick} onDragOver={handleDragOver} onDrop={handleDrop}>
      <Label>
        <UploadFileIcon />
        select or drag a WAV file</Label>
      <HiddenInput
        type="file"
        accept=".wav"
        ref={fileInputRef}
        onChange={handleFileChange}
      />
    </UploadContainer>
  )
}

const UploadContainer = styled.div`
  width: 100%;
  height: 135px;
  border-radius: 15px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  background-color: #E9E9E9;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
`

const HiddenInput = styled.input`
  display: none;
`

const Label = styled.div`
  width: 228px;
  height: 44px;
  border-radius: 10px;
  background-color: #FFFFFF;
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:8px;
`



export default UploadWavFile
